import React from 'react';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import GreetingGroup from '../components/common/Greeting.jsx';

export default function SplashPage({ handleScreenNext }) {
  return (
    <React.Fragment>
      <GreetingGroup title={'Welcome back, Alumni!'} subtitle="Kumusta na?" />
      <Typography variant="body2" color="primary">
        We want to know how you have
        <br />
        been after your stay in our
        <br />
        Dakilang Pamantasan.
      </Typography>
      <Button variant="contained" size="large" color="primary" onClick={() => handleScreenNext()}>
        Let&apos;s Get Started!
      </Button>
    </React.Fragment>
  );
}

SplashPage.propTypes = {
  handleScreenNext: PropTypes.func,
};
